import { DashboardIkn, IssueLogIkn, ManagePlanIkn, ManageTemplatesIkn, ManageUsersIkn, MappingIkn, SettingsIkn } from "../../icon/Private-Pages/Icon";


export const projects = [
    {
        title: "Project_001",
        createdBy: "Sabari",
        avatars: ["avatar1.png"],
        extraCount: 2,
    },
    {
        title: "Project_002",
        createdBy: "Sabari",
        avatars: ["avatar1.png"],
        extraCount: 2,
    },
    {
        title: "Project_003",
        createdBy: "Sabari",
        avatars: ["avatar1.png"],
        extraCount: 2,
    },
    {
        title: "Project_004",
        createdBy: "Sabari",
        avatars: ["avatar1.png"],
        extraCount: 2,
    },
    {
        title: "Project_005",
        createdBy: "Sabari",
        avatars: ["avatar1.png"],
        extraCount: 2,
    },
];

export const AdminSideBarDatas = [
    {
        id: 0,
        text: 'Dashboard',
        icon: 'https://planshareaistaorage.blob.core.windows.net/planshare-ai-sidenav-icons/material-symbols_team-dashboard.svg',
        // icon: DashboardIkn,
        path: '/admin'
    },
    {
        id: 1,
        text: 'Issue Log',
        icon: 'https://planshareaistaorage.blob.core.windows.net/planshare-ai-sidenav-icons/ooui_alert.svg',
        // icon: IssueLogIkn,
        path: '/admin/issue-log'
    },
    {
        id: 2,
        text: 'Manage Users',
        icon: 'https://planshareaistaorage.blob.core.windows.net/planshare-ai-sidenav-icons/flowbite_users-group-solid.svg',
        // icon: ManageUsersIkn,
        path: '/admin/manage-users'
    },
    {
        id: 3,
        text: 'Manage Plan',
        icon: 'https://planshareaistaorage.blob.core.windows.net/planshare-ai-sidenav-icons/Mask%20group.svg',
        // icon: ManagePlanIkn,
        path: '/admin/manage-plan'
    },
    {
        id: 4,
        text: 'Manage Templates',
        icon: 'https://planshareaistaorage.blob.core.windows.net/planshare-ai-sidenav-icons/line-md_file-filled.svg',
        // icon: ManageTemplatesIkn,
        path: '/admin/manage-templates'
    },
    {
        id: 5,
        text: 'Mapping',
        icon: 'https://planshareaistaorage.blob.core.windows.net/planshare-ai-sidenav-icons/mdi_report-box.svg',
        // icon: MappingIkn,
        path: '/admin/mapping'
    },
    {
        id: 5,
        text: 'Custom Subscrition',
        icon: 'https://planshareaistaorage.blob.core.windows.net/planshare-ai-sidenav-icons/currency_dollar_fill.svg',
        path: '/admin/custom-subscription'
    },
    {
        id: 6,
        text: 'Settings',
        icon: 'https://planshareaistaorage.blob.core.windows.net/planshare-ai-sidenav-icons/uiw_setting.svg',
        // icon: SettingsIkn,
        path: '/admin/settings'
    },
]